module.exports = __webpack_public_path__ + "static/media/font_medium.9d90c7e3.woff";